const EmailIcon = (props) => {
    return (
        <svg
          width={25}
          height={25}
          viewBox="0 0 200 200"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <circle cx={100} cy={100} r={100} fill="#6E0202" fillOpacity={0.2} />
          <path
            d="M101.055 35.5c-41.427-.58-74.66 34.862-67.676 75.418 4.736 27.522 28.4 49.182 57.305 52.91 19.49 2.515 37.71-2.859 51.503-13.437l-7.031-8.399c-11.507 8.826-26.646 13.373-43.066 11.254-23.936-3.087-43.546-21.252-47.461-44.008-5.897-34.242 21.57-63.473 56.25-62.988 29.558.414 54.474 23.838 55.371 52.07.02.605 0 1.194 0 1.848-.045 11.841-10.08 21.336-22.5 21.332-6.283-.004-11.25-4.753-11.25-10.75v-43h-11.25v4.2c-4.042-2.617-8.845-4.2-14.063-4.2-13.913 0-25.312 10.893-25.312 24.188v16.124c0 13.295 11.4 24.188 25.313 24.188 7.581 0 14.333-3.303 18.984-8.398 4.131 5.02 10.427 8.394 17.578 8.398 18.472.006 33.683-14.403 33.75-32.082 0-.71.025-1.413 0-2.184C166.417 63.931 136.701 36 101.055 35.5zm-3.868 43c7.834 0 14.063 5.953 14.063 13.438v16.124c0 7.485-6.229 13.438-14.063 13.438-7.833 0-14.062-5.953-14.062-13.438V91.938c0-7.486 6.23-13.438 14.063-13.438z"
            fill="#6E0202"
          />
        </svg>
      )
}

export default EmailIcon